module.exports = __webpack_public_path__ + "static/media/mt.93f3f23e.svg";